export function CharacterLimitDirective():ng.IDirective {
	return {
		restrict: 'A',
		link: (scope, element, attrs) => {
			let charLimit = +attrs.charLimit;
			let getTruncatedText = (text:string, length:number = charLimit) => {
				text = text.replace(/\.{3,}$/, '');
				let words = text.split(' ');
				
				if (words.length > 1) {
					let charCount = 0;
					
					// if there are multiple words, truncate at the end of one word.
					// but for one long string, truncate on the string.
					for(let i = 0; i < words.length; i++) {
						charCount += words[i].length + 1;

						if (charCount >= length && i === 0) {
							words.splice(i + 1);
							return `${words[i].slice(0, length)}...`;
						}
						else if (i < words.length - 1 && charCount + words[i+1].length > length) {
							words[i] = `${words[i]}...`;
							words.splice(i + 1);
						}
						else if (i + 1 === words.length) {
							words[i] = `${words[i]}...`;
						}
					}
					return words.join(' ');

				}
				else {
					return `${text.slice(0, length)}...`
				}
			}

			let truncate = (hasChildren:boolean) => {
				if (hasChildren) {
					let textLength = 0;
					let children = element[0].children;
					
					for (let i = 0; i < children.length; i++) {
						let child = <HTMLElement>children.item(i);
						textLength += child.innerText.trim().length;
						
						if (textLength >= charLimit) {
							let difference = textLength - charLimit;
							let fullText = child.innerText.trim();
							let textRegex = new RegExp(child.textContent.trim());
							let truncatedText = getTruncatedText(fullText, fullText.length - difference);
							child.innerHTML = child.innerHTML.replace(textRegex, truncatedText);

							if (i < children.length) {
								for (let j = children.length - 1; j > i; j--) {
									element[0].removeChild(children.item(j));
								}
							}
						}
						textLength += 1; // increment counter for spaces between words
					}
				}
				else {
					if (element.text().length > charLimit) {
						let truncatedText = getTruncatedText(element.text());
						element.text(truncatedText);
					}
				}
			};

			// for virtual repeat containers, which reuse elements no longer visible for the next list items
			scope.$watch(() => element[0].innerHTML, () => {
				truncate(element[0].children.length > 0);
			});
		}
	}
}
 


// WEBPACK FOOTER //
// ./src/util/services/characterLimit.ts